import styled from '@emotion/styled';

export const TableContainer = styled('div')`
  tr {
    .action-icon {
      visibility: hidden;
      margin-left: 5px;
    }

    &:hover {
      .action-icon {
        visibility: initial;
        cursor: pointer;
      }
    }
  }

  overflow-x: auto;
  overflow-y: auto;
  min-height: 300px;
  max-height: 500px;

  .form-control[type='checkbox'] {
    width: 16px;
    height: 16px;
  }

  .green-check {
    font-size: 24px;
    color: green;
  }

  .text-center {
    text-align: center;
  }

  .action-icon {
    cursor: pointer;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    z-index: 1;
    top: 0;
  }
`;

export const SelectWrapper = styled('div')`
  > div {
    width: 80px; //Для селекта
  }
`;
